import { CHCMedicareShoppingWizard } from './medicare-shopping-wizard.component.js';
export { CHCMedicareShoppingWizard };

customElements.define('chcapp-medicare-shopping-wizard', CHCMedicareShoppingWizard);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-medicare-shopping-wizard': CHCMedicareShoppingWizard;
  }
}
